module.exports = __webpack_public_path__ + "static/banner-tablet-6ac66d536ec463d4df5c04c9ce5d4880.png";